import React from 'react';
import { Button, Stack } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import TableChart from '@mui/icons-material/TableChart';
import Help from '@mui/icons-material/Help';
import { useNavigate } from 'react-router-dom';
const ResultModeHeader = ({ onTableClick, onGraphClick, onHelpClick, }) => {
    const navigate = useNavigate();
    return (React.createElement(Stack, { sx: {
            marginTop: "0px",
            marginBottom: "3px",
            width: "100%",
            minWidth: "100%",
        }, direction: {
            xs: "column",
            sm: "row",
        }, spacing: 2 },
        React.createElement(Button, { startIcon: React.createElement(ArrowBackIcon, null), onClick: () => navigate("/?id=1"), sx: { fontSize: "0.9em" } }, "Search"),
        React.createElement(Button, { sx: {
                backgroundColor: "#ffffff",
                color: "#005533",
                "&:hover": { backgroundColor: "#f1f1f1", color: "#333333" },
                fontSize: "0.9em",
            }, startIcon: React.createElement(TableChart, null), onClick: onTableClick }, "Table"),
        React.createElement(Button, { sx: {
                backgroundColor: "#ffffff",
                color: "#005533",
                "&:hover": { backgroundColor: "#f1f1f1", color: "#005533" },
                fontSize: "0.9em",
            }, startIcon: React.createElement(TableChart, null), onClick: onGraphClick }, "Graph"),
        React.createElement(Button, { sx: {
                backgroundColor: "#ffffff",
                color: "#005533",
                "&:hover": { backgroundColor: "#f1f1f1", color: "#005533" },
                fontSize: "0.9em",
            }, startIcon: React.createElement(Help, null), onClick: onHelpClick }, "Help"),
        React.createElement("div", { style: { flexGrow: 1 } })));
};
export default ResultModeHeader;
